import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { BsDatepickerModule } from 'ngx-bootstrap';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DataTablesModule } from 'angular-datatables';
import { ChartsModule } from 'ng2-charts';
import { ChannelDiscussionService } from './channel-discussion.service';
import { CommonModule } from '@angular/common';
import { Daterangepicker } from 'ng2-daterangepicker';
import { ChannelDiscussionManagerComponent } from './channel-discussion.component';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';
import { SharedModule } from 'app/_shared/shared.module';
import { ReportsComponentModule } from 'app/views/reports-component/reports-component.module';
import { CKEditorModule } from 'ng2-ckeditor';
import {NgxPaginationModule} from 'ngx-pagination'; // <-- import the module

const routes: Routes = [
  {
    path: '',
    component: ChannelDiscussionManagerComponent,
    data: {
      title: 'Tỷ trọng thảo luận theo nguồn'
    },
  }
];
@NgModule({
  imports: [
    ChartsModule,
    TabsModule,
    BsDatepickerModule.forRoot(),
    CommonModule,
    DataTablesModule,
    Daterangepicker,
    HttpClientModule,
    RouterModule.forChild(routes),
    AngularMultiSelectModule,
    FormsModule,
    SharedModule,
    ReactiveFormsModule,
    ReportsComponentModule,
    CKEditorModule,
    NgxPaginationModule
  ],
  declarations: [ChannelDiscussionManagerComponent],
  providers: [ChannelDiscussionService]
})
export class ChannelDiscussionModule { }



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/views/reports-module/channel-discussion/channel-discussion.module.ts